import React from 'react';

import { ModalBox } from './style/ModalBox';

const Modal = (props) => {
	const { sourceId } = props;
	const title = `Você escolheu o briefing ${sourceId}`;
	const text = 'As respostas desse briefing foram carregadas no novo briefing. Você pode alterar todos os campos que quiser!';
	const button = 'Continuar';

	const {
		closeAction,
		buttonAction,
	} = props;

	return (
		<ModalBox>
			<div className="modal-content">
				<button
					type="button"
					className="close"
					aria-label="Close"
					onClick={closeAction}
				>
					<span aria-hidden="true">&times;</span>
				</button>

				<div className="modal-body">
					<h5>{title}</h5>
					<p>{text}</p>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-success btn-lg btn-block"
						onClick={buttonAction}
					>
						{button}
					</button>
				</div>
			</div>

			<div className="modal-overlay" id="modal-overlay" />
		</ModalBox>
	);
};

export default Modal;
